import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import shareIcon from "../../img/icons/shareIcon.svg";
import localization from "../../data/config"
import * as EVENTS from "../../constants/config/dtm";
import { track } from "../../actions/dtm";
import "./style.css";

const { copyLinkLabel, sendToEmailLabel } = localization;

/**
 * @name Share
 * @constant
 * @function
 * @description initiates the share functionality, copy to clipboard and send to email
 */
 const Share = () => {
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [isOpen, setIsOpen] = useState(false),
    dispatch = useDispatch(),
    { title } = useSelector((state) => ({
      title: state.app.title,
    })),
    dropdownContainerRef = useRef(null),
    shareLinksRef = useRef([null, null]);
 
  const [activeIndex, setActiveIndex] = useState(0);
 
   /**
   * @name handleToggle
   * @constant
   * @function
   * @description handles the toggle state of the share modal
   */
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
 
//useEffect to handle the closing of the dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownContainerRef.current && !dropdownContainerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
 
  /**
   * @name copyToClipboard
   * @constant
   * @function
   * @description copies the URL to clipboard
   */
   const copyToClipboard = async () => {
    const urlToCopy = window.location.href;
    try {
        await navigator.clipboard.writeText(urlToCopy);
    } catch( err ) {
        console.error( err );
    }
    handleToggle();
}
 
  /**
   * @name sendEmail
   * @constant
   * @function
   * @description shares the page title as boday and url as subject to email redirect
   */
  const sendEmail = () => {
    const pageURL = window.location.href;
    window.location = `mailto:?subject=PST%20-%20${encodeURIComponent(
      title
    )}&body=${encodeURIComponent(pageURL)}`;
    dispatch(track(EVENTS.SHARE));
    handleToggle();
  };
 
  /**
  * Handles the key press event, triggering an action if Enter key is pressed.
  *
  * @param {KeyboardEvent} event - The key press event.
  */
 
 
  const handleKeyDown = (e) => {
    switch (e.key) {
      case "ArrowDown":
      case "ArrowUp":
        e.preventDefault();
        const direction = e.key === "ArrowDown" ? 1 : -1;
        const options = document.querySelectorAll(".share-modal li");
        let newIndex = focusedIndex + direction;
 
        if (newIndex < 0) {
          newIndex = options.length - 1;
        } else if (newIndex >= options.length) {
          newIndex = 0;
        }
 
        setFocusedIndex(newIndex);
        options[newIndex].focus();
        break;
 
        case 'Enter':
          setIsOpen(!isOpen);
          break;
 
      case "Escape":
        setIsOpen(false);
        break;
 
      default:
        break;
    }
  };
 
  const handleLinkClick = (index) => {
    setActiveIndex(index);
    if(index==0) copyToClipboard();
    if(index==1) sendEmail();
  };
 
  const handleLinkFocus = (index) => {
    setActiveIndex(index);
  };
 
  return (
    <div
      className="share"
      ref={dropdownContainerRef}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      role="combobox"
      aria-expanded={isOpen}
    >
      <img
        height="24"
        width="24"
        src={shareIcon}
        alt="Share"
        role="button"
        onClick={handleToggle}
        className={`shareIcon ${isOpen ? "shareIcon-border" : ""}`}
        aria-haspopup="true"
        tabIndex={0}
   
      />
      {isOpen && (
        <div className="share-container">
          <ul className="share-modal" role="menu">
            <li
              ref={(el) => (shareLinksRef.current[0] = el)}
              onClick={() => handleLinkClick(0)}
              onFocus={() => handleLinkFocus(0)}
              className={`sharePopupText ${activeIndex === 1 ? "active" : ""}`}
              role="menuitem"
              tabIndex={-1}
              aria-current={activeIndex === 0 ? "true" : null}
            >
              {copyLinkLabel}
            </li>
            <li
              ref={(el) => (shareLinksRef.current[1] = el)}
              onClick={() => handleLinkClick(1)}
              onFocus={() => handleLinkFocus(1)}
              className={`sharePopupText ${activeIndex === 1 ? "active" : ""}`}
              role="menuitem"
              tabIndex={0}
            >
              {sendToEmailLabel}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};
 
export default Share;